import React from "react";
import Contact from "../../src/components/Home/Contact";

import BreadCrumb from "../../src/components/Shared/BreadCrumb";
import server from "../../src/api/server";
import { FormattedMessage, useIntl } from "react-intl";
import { NextSeo } from "next-seo";
import dynamic from "next/dynamic";
const Services = dynamic(() => import("../../src/components/Home/Services"), {
  ssr: false,
});
const ServicesPage = ({
  servicesData,
  socialsData,
  breadBackground,
  contactUsBack,
  servicesCategories,
  metaDataSections,
}) => {
  const servicesMeta = metaDataSections?.find(
    (item) => item?.slug === "services"
  );
  const { locale, formatMessage } = useIntl();
  return (
    <>
      <NextSeo
        title={
          servicesMeta?.name[locale] ||
          formatMessage({ id: servicesMeta?.slug })
        }
        description={
          servicesMeta?.description[locale] ||
          formatMessage({ id: "Walid Ben Abdulaziz Ben mouzan" })
        }
        additionalMetaTags={[
          {
            name: "keywords",
            content: "",
          },
          {
            name: "description",
            content: "",
          },
        ]}
      />
      <div className="services-page">
        <BreadCrumb
          title={<FormattedMessage id="services" />}
          pageTitle={<FormattedMessage id="services" />}
          breadBackground={breadBackground}
        />
        <div className="services-body">
          <Services {...{ servicesCategories, servicesData }} />
        </div>
      </div>
    </>
  );
};

export const getStaticProps = async (ctx) => {
  const servicesResponse = await server.get("/pages/services");
  const socialsResponse = await server.get("/settings/socials");
  const metaDataResponse = await server.get("/pages/metaData");
  const servicesCategoriesResponse = await server.get(
    "/pages/services-categories/sections"
  );
  let breadBack, contactUsBack;
  try {
    const backgroundResponse = await server.get("/pages/backgrounds");
    breadBack = backgroundResponse?.data?.data?.page?.sections?.find(
      (sec) => sec?.slug === "breadcrumbs"
    )?.image;
    contactUsBack = backgroundResponse?.data?.data?.page?.sections?.find(
      (sec) => sec?.slug === "contactUs"
    )?.image;
  } catch (err) {
    console.log(err);
  }

  return {
    revalidate: 60,
    props: {
      servicesData: servicesResponse?.data?.data?.page?.sections,
      socialsData: socialsResponse?.data?.data?.socials,
      servicesCategories: servicesCategoriesResponse?.data?.data?.sections,
      metaDataSections: metaDataResponse?.data?.data?.page?.sections,
      breadBackground: breadBack
        ? `${process.env.NEXT_PUBLIC_MAIN_URL}/${breadBack}`
        : "",
      contactUsBack: contactUsBack
        ? `${process.env.NEXT_PUBLIC_MAIN_URL}/${contactUsBack}`
        : "",
    },
  };
};

export default ServicesPage;
